export function isObjectEmpty(obj: any) {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }
  return true;
}

export function getURLParam(url: string, key: string) {
  if (!url || !key) {
    return undefined;
  }
  try {
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);
    const value = params.get(key);
    return value !== null ? value : undefined;
  } catch (error) {
    return undefined;
  }
}
